/* -------- packages -------- */
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  CardTitle
} from "reactstrap";
/* -------- ------- -------- */

export default function DashboardLayout ({containerClass, sideBar, children }) {
  return (
    <Container fluid className={"w-100 d-flex flex-row align-items-center p-0 align-items-center justify-content-center " + containerClass}>
      {
        sideBar ?
        (
          <Row className=" w-100 d-flex flex-row justify-content-between">
          <Col xl={2} lg={3} className="projectSidebar p-0 d-none d-lg-block">
            <Row className="w-100 h-100 justify-content-center">
              <Col xl={12} lg={10} className="p-0">

                {sideBar}
                
              </Col>
            </Row>
          </Col>
          
          <Col xl={10} lg={9} className="projectContentContainer p-0">

            {children}

          </Col>
      </Row>
        )
        :
        (
          <Row className=" w-100 d-flex flex-row justify-content-between">
          
          <Col xl={12} lg={12} className="projectContentContainer p-0">

            {children}

          </Col>
      </Row>
        )
      }
    </Container>
  )
}